/**
 * Format a compass bearing for the Direction input. The value is normalised
 * into `[0, 360)` *after* rounding so that bearings like `359.5` (which round
 * to `360`) wrap to `0` — the same value the codec accepts and the same value
 * the draft-pin memo uses to rotate the arrow. Without this, the input would
 * read `360` while the marker pointed north and the two would silently disagree.
 */
export function formatBearing(value: number): string {
  const rounded = Math.round(value);
  const normalised = ((rounded % 360) + 360) % 360;
  return normalised.toString();
}
